module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/stop-c518e8d33240ebd217c877ca974de8df.svg";